import { makeStyles } from "tss-react/mui"
import { CircularProgress, Grid } from "@mui/material"

const useStyles = makeStyles()((theme) => ({
    wrap: {
        margin: "15rem 0",
    },
}))

type LoadingSpinnerProps = Readonly<{
    className?: string
}>

export function LoadingSpinner({ className }: LoadingSpinnerProps) {
    const { classes, cx } = useStyles()
    return (
        <Grid container justifyContent="center" className={cx(classes.wrap, className)}>
            <CircularProgress size={70} />
        </Grid>
    )
}
